import {Component} from '@angular/core';

@Component({
  selector: 'app-user-roles-help',
  standalone: true,
  imports: [],
  templateUrl: './user-roles-help.component.html',
  styleUrl: './user-roles-help.component.scss',
})
export class UserRolesHelpComponent {
}
